import React, { FC } from 'react';
import styles from './EditButton.module.scss';
import Icon from '../../IconDS22';

export type Props = {
  onClick: () => void;
};

const EditButton: FC<Props> = ({ onClick }) => (
  <button
    type="button"
    className={styles.root}
    onClick={onClick}
  >
    <Icon id="note" />
  </button>
);

export default EditButton;
